const countdown = (haveDay = true) => {
  var today = new Date();

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  var diffMs = (tomorrow - today); // milliseconds between now & Christmas
  var minutes = Math.floor((diffMs / 1000) / 60);

  _countdown(minutes);

  function _countdown(minutes) {
    var targetDate = new Date().getTime() + ((minutes * 60) * 1000);
    var days, hours, minutes, seconds;

    var countdown = document.querySelectorAll('.js-countdown');

    getCountdown();
    setInterval(function () { getCountdown(); }, 1000);

    function getCountdown() {

      // find the amount of "seconds" between now and target
      var currentDate = new Date().getTime();
      var secondsLeft = (targetDate - currentDate) / 1000;

      if (secondsLeft >= 0) {
        days = pad(parseInt(secondsLeft / 86400));
        secondsLeft = secondsLeft % 86400;

        hours = pad(parseInt(secondsLeft / 3600));
        secondsLeft = secondsLeft % 3600;

        minutes = pad(parseInt(secondsLeft / 60));
        seconds = pad(parseInt(secondsLeft % 60));

        if (countdown) {
          for (var i = 0; i < countdown.length; i++) {
            countdown[i].innerHTML = `
          ${haveDay ?
            `<div class="countdown__time">${days}
              <span class="label">Hari</span>
            </div>
            <span class="countdown__separator">:</span>` : ''}
            <div class="countdown__time">${hours}
              <span class="label">Jam</span>
            </div>
            <span class="countdown__separator">:</span>
            <div class="countdown__time">${minutes}
              <span class="label">Menit</span>
            </div>
            <span class="countdown__separator">:</span>
            <div class="countdown__time">${seconds}
              <span class="label">Detik</span>
            </div>
          `;
          }
        }
      }
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
  }
}

export default countdown;
